import { defineStore } from 'pinia';

export type GamePhase = 'idle' | 'ready' | 'running' | 'paused' | 'dying' | 'gameover';

interface GameState {
  phase: GamePhase;
  coinCount: number;
  lifeCount: number;
  muted: boolean;
}

export const useGameStore = defineStore('game', {
  state: (): GameState => ({
    phase: 'idle',
    coinCount: 0,
    lifeCount: 3,
    muted: false,
  }),
  getters: {
    isPaused(state): boolean {
      return state.phase === 'paused';
    },
    isRunning(state): boolean {
      return state.phase === 'running';
    },
  },
  actions: {
    setPhase(next: GamePhase): void {
      this.phase = next;
    },
    start(): void {
      this.phase = 'running';
    },
    pause(): void {
      this.phase = 'paused';
    },
    resume(): void {
      this.phase = 'running';
    },
    markDeath(): void {
      this.phase = 'dying';
    },
    markGameOver(): void {
      this.phase = 'gameover';
    },
    reset(): void {
      this.phase = 'idle';
      this.coinCount = 0;
      this.lifeCount = 3;
    },
    setCounts(coin: number, life: number): void {
      this.coinCount = Math.max(0, coin | 0);
      this.lifeCount = Math.max(0, Math.min(3, life | 0));
    },
    setMuted(m: boolean): void {
      this.muted = !!m;
      try {
        localStorage.setItem('audio:muted', this.muted ? '1' : '0');
      } catch {
        // Игнорируем ошибки сохранения (приватный режим, квота и т.п.)
      }
    },
  },
});
